/**
 * Ajuda dos campos das configuracoes da empresa.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
import { ajudaDasVersoesDosTermos } from './terms';

export const ajuda: Record<string, Record<string, string>> = {
  // Aba Acesso das configuracoes (P-ACE-1): a configuracao do portal do OnPoint.
  '/configuracoes': {
    // Aba Feriados (P-BI-1): o calendario da apuracao do prazo em dias uteis.
    'Inicio do horario comercial':
      'Hora em que o prazo das esteiras comeca a correr no dia util. Nasce com 09:00, como o sistema anterior. A regra de apuracao ainda nao foi homologada.',
    'Fim do horario comercial':
      'Hora em que o prazo para de correr no dia util. Precisa ser depois do inicio. Nasce com 18:00.',
    'Data do feriado':
      'Dia que nao conta no prazo das esteiras. Um feriado por dia; o fim de semana ja nao conta.',
    'Nome do feriado': 'Nome que aparece na lista, com ate 120 caracteres.',
    'Publicar a tela de acesso da empresa':
      'Ligada, a tela de acesso da empresa (/entrar/identificador, ou o dominio proprio) mostra a marca antes do acesso. Desligada, mostra a da plataforma e responde como se a empresa nao existisse, para que ninguem descubra por ali quais empresas usam a plataforma.',
    'Titulo da tela de acesso':
      'Texto grande do painel de marca, como "Bem-vindo ao Portal". Ate 120 caracteres. Mudar exige a identidade visual propria no plano.',
    'Primeiro subtitulo':
      'Nome que aparece ao lado do logotipo no painel de marca. Ate 120 caracteres.',
    'Segundo subtitulo': 'Frase de apoio abaixo do titulo. Ate 200 caracteres.',
    'URL do logotipo branco':
      'Logotipo para fundo escuro, usado no painel de marca. Endereco http ou https, ou caminho da aplicacao.',
    'URL da imagem de fundo':
      'Imagem do painel de marca. Tem precedencia sobre o degrade. Endereco http ou https, ou caminho da aplicacao.',
    'Fundo em degrade':
      'Usa as cores do degrade no painel de marca. Precisa de pelo menos duas cores.',
    'Cores do degrade':
      'Ate quatro cores no formato hexadecimal de seis digitos, separadas por virgula, como #0a1b3d, #1d6cf2.',
    'Mostrar a tela de acesso do corretor':
      'A tela /entrar/identificador/corretor, com a marca da empresa. O corretor tambem entra pela tela principal: a chave e da tela, e nao do acesso.',
    'Acesso de assessoria':
      'A assessoria ainda nao existe na plataforma (regra CFG-003 pendente), e por isso a chave nao liga.',
    'Autocadastro de corretora':
      'O autocadastro ainda nao existe na plataforma e depende de decisao do dono do produto.',
    'Endereco do cadastro publico de corretores':
      'Endereco publico, como sudaseg, do cadastro de corretores com usuario e senha na hora. So abre com o autocadastro ligado e a consulta a SUSEP configurada no servidor. Letras minusculas, digitos e hifen.',
    'Acesso por e-mail e senha':
      'Fica ao lado do login corporativo. So pode ser desligado quando houver login corporativo.',
    'Contato de suporte':
      'Destino de "Nao tem acesso?" na tela de acesso e do contato da tela de manutencao. Endereco http, https ou mailto.',
    'Endereco de redirecionamento do acesso':
      'O valor ainda nao tem uso confirmado. E guardado, e nao muda nada na tela ate a confirmacao.',
    'Bloqueio por inatividade (minutos)':
      'Tempo sem uso que bloqueia a sessao e pede a senha de novo. O valor padrao nao e conhecido, e por isso nasce desligado (zero). Ligado, de 5 a 480 minutos.',
    'Ligar o aviso de manutencao':
      'Mostra a mensagem no topo de todas as telas da empresa e na tela de acesso. Nao tira ninguem do sistema.',
    'Mensagem do aviso de manutencao':
      'Obrigatoria para ligar o aviso. Ate 500 caracteres.',
    // P-TOM-C1: meios de pagamento da conta do tomador.
    'Nome do meio de pagamento':
      'Como o meio aparece na conta bancaria do tomador. Ate 120 caracteres, sem repetir outro meio da empresa. A conta guarda o nome do momento da inclusao.',
    // P-USU-2: aba Termos, com o mesmo texto da aba Versoes dos termos de
    // /termos-aceite.
    ...ajudaDasVersoesDosTermos,
    // P-EST-1: prioridades do cartao das esteiras.
    'Nome da prioridade':
      'Como a prioridade aparece no cartao das esteiras. A chave nasce do nome e nao muda. Ate 60 caracteres, sem repetir outra prioridade.',
    Nivel: 'De 0 a 99. O maior e o mais urgente e vem antes na coluna do quadro.',
  },
};
